import React, { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { sendGETRequest } from "./sendRequest";

interface Props {
	children: React.ReactNode;
}

export default function ProtectedRoute({ children }: Props) {
	const hasValidated = useRef(false); // Track if validation has occurred

	const [isLoading, setIsLoading] = useState(true);
	const [isValid, setIsValid] = useState(true);

	const checkToken = async () => {
		hasValidated.current = true;

		try {
			const response = await sendGETRequest("/logins/validate-token", {});

			if (response.success) {
				setIsValid(true);
			} else {
				alert("Session expired. Redirecting to login page...");
				setIsValid(false);
			}
		} catch (err) {
			console.log("Session expired. Redirecting to login page...");
			setIsValid(false);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (!hasValidated.current) {
			checkToken();
		}
	}, []);

	if (isLoading) {
		return <div>Loading...</div>; // Optionally show a loading state
	}

	if (!isValid) {
		return <Navigate to="/login" replace />; // Redirect to login if token is invalid
	}

	return <>{children}</>;
}
